<template>
  <div>
    <div>
      <span class="xbed-sub-title">导入补录记录</span>
    </div>
    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>订单管理</BreadcrumbItem>
        <BreadcrumbItem>所有订单</BreadcrumbItem>
        <BreadcrumbItem>导入补录记录</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <br>
    <Form inline @submit.native.prevent='preventSubmit'>
      <FormItem label='导入日期' :label-width='100'>
        <DatePicker type='daterange' v-model="creatTime" :start-date='nowDate' placeholder="请选择使时间" class="date-time" style="width: 230px"></DatePicker>
      </FormItem>
      <FormItem>
        <Button type='primary' @click='keyWordsQuery'>查询</Button>
      </FormItem>
      <span style="color:red;margin-left:50px;">*补录失败的订单请检查数据是否正确，补录成功的订单请勿重复导入</span>
    </Form>
    <div>
      <Table stripe :columns="columns" :data="dataList" style="width:1104px;" :loading='recordLoading'></Table>
      <Page :total="listTotal" show-sizer style="marginTop:15px;" :current='page' :page-size='size' @on-change='changePage' @on-page-size-change='changePageSize'></Page>
    </div>
  </div>
</template>

<script>
import Moment from "moment";
import Utils from "@/utils";
import API from "@/api";
  export default {
    created() {
      this.token = Utils.findFromLocalStorage( "vue-token" );
      this.username = Utils.findFromLocalStorage( "vue-username" );
      this.env = Utils.findFromLocalStorage( "env", "dev" );
    },
    data() {
      return {
        nowDate: Moment(new Date() - 86400000 * 30)._d,
        creatTime: [
          Moment().subtract(60, 'day').format("YYYY-MM-DD"),
          Moment().format('YYYY-MM-DD')
        ],
        dataList:[],
        listTotal:0,
        page:1,
        size:10,
        recordLoading:false,
        columns:[
          {
            title: '导入文件名',
            key: 'fileName',
            align:'center',
            width:200
          },
          {
            title: '处理状态',
            key: 'state',
            align:'center',
            width:100,
            render: (h,params)=>{
              const status = ['','处理中','完成'][params.row.state]
              return h('div',{},status)
            }
          },
          {
            title: '导入数据量',
            key: 'importNumber',
            align:'center',
            width:150
          },
          {
            title: '补录成功量',
            key: 'successNumber',
            align:'center',
            width:150
          },
          {
            title: '补录失败量',
            key: 'failedNumber',
            align:'center',
            width:150
          },
          {
            title: '导入时间',
            key: 'createDate',
            align:'center',
            width:200,
            render:(h,params) =>{
              const date = params.row.createDate ? Moment(params.row.createDate).format('YYYY-MM-DD HH:mm:ss'):''
              return h('div',{},date)
            }
          },
          {
            title: '操作人',
            key: 'createName',
            align:'center',
            width:150
          },
        ]
      }
    },
    mounted() {
      this.$Notice.config( {
        top: 200
      });
      this.queryList()
    },
    methods: {
      async queryList(){
      let param = {
        pageNum:this.page,
        pageSize:this.size,
        createTimeBegin:this.creatTime[0] ? Moment( this.creatTime[0] ).format( 'YYYY-MM-DD HH:mm:ss' ) : "",
        createTimeEnd:this.creatTime[1] ? Moment( this.creatTime[1] ).format( 'YYYY-MM-DD 23:59:59' ) : "",
        type:2
      }
      this.recordLoading = true;
      const resp = (await API.omsAPI[this.env].order.batchAdjustmentRecordList(param,this.token)).data;
      this.recordLoading = false;
      if ( resp.retCode ) {
        this.$Notice.error( {
          title: "获取列表失败",
          desc: resp.msg
        } );
        return
        }
      this.dataList = resp.list
      this.listTotal = resp.total
    },
      keyWordsQuery() {
        this.page = 1;
        this.queryList()
      },
      changePage(page){
        this.page = page
        this.queryList()
      },
      changePageSize(size){
        this.page = 1;
        this.size = size;
        this.queryList()
      },
      preventSubmit() {
        return false;
      }
    }
  }
</script>
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/pages/order/supplementary-order.vue